import React from "react";
import axios from "axios";

const url = "https://redemeaiyg.execute-api.us-east-1.amazonaws.com/user";

const changePasswordMutation = `
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
        status
        errors
        message
    }
  }
`;

function Password() {
  const [data, setData] = React.useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [message, setMessage] = React.useState("");
  const [errors, setErrors] = React.useState<string[]>([]);
  const [disabled, setDisabled] = React.useState(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    setDisabled(false);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (data.newPassword !== data.confirmPassword) {
      setErrors(["New password and confirm password do not match"]);
      return;
    } else {
      setErrors([]);
    }

    setDisabled(true);

    const graphqlQuery = {
      query: changePasswordMutation,
      variables: {
        input: {
          oldPassword: data.oldPassword,
          newPassword: data.newPassword,
        },
      },
    };
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(`${url}`, graphqlQuery, config)
      .then((res) => {
        const data = res.data.data.changePassword;
        if (data.status > 199 && data.status < 300) {
          setData({ oldPassword: "", newPassword: "", confirmPassword: "" });
          setMessage(data.message);
        } else {
          setErrors(data.errors);
        }
      })
      .catch((err) => {
        setErrors([err.message]);
      });
  };
  React.useEffect(() => {
    return () => {
      setData({ oldPassword: "", newPassword: "", confirmPassword: "" });
      setMessage("");
      setErrors([]);
      setDisabled(true);
    };
  }, []);
  React.useEffect(() => {
    const time = setTimeout(() => {
      setMessage("");
    }, 5000);
    return () => {
      clearTimeout(time)
    }
  }, [message]);

  return (
    <div>
      <h1>Change Password</h1>
      {message && <div className="message">{message}</div>}
      {errors.length > 0 && <div className="error">{errors[0]}</div>}
      <form className="form" onSubmit={handleSubmit}>
        <label htmlFor="oPassword">Old Password</label>
        <input
          id="oPassword"
          type="password"
          placeholder="Old Password"
          name="oldPassword"
          value={data.oldPassword}
          onChange={handleChange}
        />
        <label htmlFor="nPassword">New Password</label>
        <input
          id="nPassword"
          type="password"
          placeholder="New Password"
          name="newPassword"
          value={data.newPassword}
          onChange={handleChange}
        />
        <label htmlFor="cPassword">Confirm Password</label>
        <input
          id="cPassword"
          type="password"
          placeholder="Confirm Password"
          name="confirmPassword"
          value={data.confirmPassword}
          onChange={handleChange}
        />
        <button type="submit" className="btn-primary" disabled={disabled}>
          Change
        </button>
      </form>
    </div>
  );
}

export default Password;
